export default {
  detailsPage: {
    hiddenClass: 'hidden',
    sectionContainer: 'sectionContainer',
    sectionWrapper: 'sectionWrapper',
    leftWrapper: 'leftWrapper',
    displayContent: 'displaycontent',
    imageClass: 'imageClass',
    contentWrapper: 'contentWrapper',
    viewShareArticle: 'viewShareArticle fixed z-10',
    articleSections: 'content-section relative',
    articlepromos: 'articlepromos',
    breadcrumbContainer:
      'breadcrumbContainer border-t-1 border-greyLine border-solid mt-30',
    wasThisHelpful:
      'wasThisHelpful bg-light-grey sm:pb-50 md:pb-60 md:pt-50 relative z-3 bg-white',
    accordionBlock:
      'accordionBlock p-15 rounded-6 text-18 font-HelveticaNeueLight',
    carouselHeading:
      'w-full font-BornreadyRegular text-center md:text-left text-36 lg:text-40 pt-40',
    hidingWrapper: 'hidingWrapper w-full relative z-3 bg-white',
    socialShareArticle:
      'social-share-section fixed bottom-0 left-0 ml-15 lg:mx-auto mb-20 z-3 lg:w-container lg:right-0',
    hairAdvisor: 'hair-care-section fixed bottom-0 right-0 mr-10 mb-0 z-4 ',
    videoArticle: {
      videoArticleWrapper: 'lg:ml-10p lg:mr-10p mb-35',
      articleTitleWrapper: 'my-10 lg:p-0 sm:px-15 lg:flex lg:flex-col-reverse',
      articleViews: 'text-black font-medium',
      articleTitle:
        'font-BebasNeueRegular text-36 lg:text-45 leading-36 lg:leading-50 font-bold tracking-wider7x transition-1 mb-8',
    },
    articleBanner: {
      hiddenClass: 'hidden',
      articleSections:
        'banner-section banner article-banner-bg banner-bottom-shadow relative mb-30 article-details-banner',
      imageWrapper: 'imageWrapper relative z-1',
      titleWrapper: 'titleWrapper text-white',
      viewsArticle: 'viewsArticle',
      viewsTitleWrapper:
        'lg:w-articleContainer mx-auto absolute bottom-0 left-0 right-0 mb-40 sm:pl-70 sm:pr-20 lg:px-0 z-2',
      heroImageTitle:
        'font-BebasNeueRegular text-36 lg:text-56 leading-36 lg:leading-50 lg:font-medium tracking-wider7x transition-1',
    },
    relatedProduct: {
      mainWrapper:
        'related-product-section lg:max-w-container mx-auto sm:pl-20 sm:pr-20 lg:px-15 sm:pt-40 lg:pt-50 lg:pb-10',
      headingWrapper: 'text-32 lg:text-36 font-BornreadyRegular',
      heading: 'leading-45 font-hairline lg:w-5/6 mx-auto mb-45',
    },
    moreOnThisTopic: {
      mainWrapper:
       "relative",
      headingWrapper: 'text-32 lg:text-36 font-BornreadyRegular',
      heading: 'leading-45 font-hairline lg:w-5/6 mx-auto mb-45',
    },
    peopleAlsoAsked: {
      mainWrapper:
        'people-also-asked-section lg:max-w-innerContainer mx-auto sm:pl-20 sm:pr-20 sm:pt-40 sm:pb-50 lg:pt-50 lg:pb-80',
      headingWrapper: 'text-32 lg:text-36 font-BornreadyRegular',
      heading: 'leading-45 font-hairline mx-auto mb-35',
      accordiontxt:
        'accordiontxt font-HelveticaNeueLight text-black bg-lightGrey p-18 rounded-6 m-0 mb-1 text-18',
      expand: 'expand',
      collapse: 'collapse',
    },
  },
  listPage: {
    hairAdvisor: 'hair-care-section fixed bottom-0 right-0 mr-10 mb-0 z-4 ',
    hiddenClass: 'hidden',
    sectionContainer: 'sectionContainer',
    sectionWrapper: 'sectionWrapper',
    leftWrapper: 'leftWrapper',
    contentWrapper: 'contentWrapper',
    articleSections: 'articleSections',
    articlepromos: 'articlepromos',
    breadcrumbContainer:
      'breadcrumbContainer border-t-1 border-greyLine border-solid mt-30',
    container: 'lg:w-container mx-auto md:w-11/12',
    carouselHeading:
      'w-full font-BornreadyRegular sm:pl-20 md:pl-0  md:text-left text-36 lg:text-40 py-40',
  },
  articleCarouselParent: 'w-full flex flex-wrap',
  articleCarouselCardWidth: 'w-full',
  articleRelatedProdDiv: 'article_products',
};
